import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class Spinner {

  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);

  isLoading$ = this.isLoadingSubject.asObservable();

  constructor() { }

  show(): void {
    this.isLoadingSubject.next(true);
  }

  // Method to hide the spinner
  hide(): void {
    this.isLoadingSubject.next(false);
  }
}

